module.exports = "<ui-form-element [title]=\"title\"\n                 [description]=\"description\"\n                 [highlightPhrase]=\"highlightPhrase\">\n\n    <ui-radio [value]=\"value\"\n              [id]=\"id\"\n              [altValue]=\"altValue\"\n              [disabled]=\"disabled\">\n    </ui-radio>\n\n</ui-form-element>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/form-elements/fe-radio/fe-radio.html
// module id = 1077
// module chunks = 3